import axios from "axios";

//获取数据列表
export const getTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/smartScreen/table",
        data:params
    })
}

//新增
export const smartScreenAdd= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/smartScreen/add",
        data:params
    })
}

//获取详情
export const smartScreenInfo= (id) => {
    return axios({
        method:'get',
        url: "/system-ya/smartScreen/info/"+id,
    })
}

//获取数据列表
export const smartScreenUpd= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/smartScreen/upd",
        data:params
    })
}

//删除
export const smartScreenDeleted= (id) => {
    return axios({
        method:'get',
        url: "/system-ya/smartScreen/remove/"+id,
    })
}

//获取好友列表
export const getAgedRelativeFriendsTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/agedRelativeFriends/table",
        data:params
    })
}

//新增好友
export const agedRelativeFriendsAdd= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/agedRelativeFriends/add",
        data:params
    })
}

//删除好友关系
export const smartAgedRelativeFriendsDeleted = (id) => {
    return axios({
        method:'get',
        url: "/system-ya/agedRelativeFriends/remove/"+id,
    })
}

//设置紧急联系人
export const setUpEc = (id) => {
    return axios({
        method:'get',
        url: "/system-ya/agedRelativeFriends/setUpEc/"+id,
    })
}

//解除紧急联系人
export const secureUpEc = (id) => {
    return axios({
        method:'get',
        url: "/system-ya/agedRelativeFriends/secureUpEc/"+id,
    })
}

//通话记录
export const sendYangQuanYY= (data) => {
    return axios({
        method:'post',
        url: "/system-nb/api/nbiot/sendYangQuanYY",
        data:data
    })
}

// 智能屏卡片工作台（已绑定按长者分页，未绑定按设备分页）
export const getSmartScreenWorkbench = (params) => {
    return axios({
        method: 'post',
        url: '/system-ya/smartScreen/workbench',
        data: params
    })
}

// 长者下拉选项，用于在工作台内完成绑定或调整绑定
export const getSmartScreenAgedOptions = () => {
    return axios({
        method: 'post',
        url: '/system-ya/aged/list'
    })
}
